import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Actions, ofActionSuccessful } from '@ngxs/store';
import { take } from 'rxjs/operators';

import { CoreFacade } from './../store/core.facade';
import { LoadContextSuccessAction } from './../store/core.actions';

@Injectable({ providedIn: 'root' })
export class ContextResolverService {
    constructor(private coreFacade: CoreFacade, private actions$: Actions) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
        this.coreFacade.loadContext();

        return this.actions$
            .pipe(ofActionSuccessful(LoadContextSuccessAction))
            .pipe(take(1))
            .toPromise();
    }
}
